import { Component } from '@angular/core';

@Component({
  selector: 'app-abbott-wrapper',
  template: `
    <router-outlet></router-outlet>

    <app-footer [noNavButtons]="true"></app-footer>
  `,
  styleUrls: ['./abbott-wrapper.component.scss']
})
export class AbbottWrapperComponent {
  constructor(
  ) {}


}
